import { Checkbox, FormControl, FormControlLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal} from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useFetchCreatereccurenceMutation } from "../../../slice/logdetailSlice";
import { toast } from "react-toastify";


const TaskRecurrence = ({ disabled, id, recurrenceList, refetch }) => {
  const { handleSubmit, watch, control, reset } = useForm();
  const [showPopup, setShowPopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [createTaskRecurrence] = useFetchCreatereccurenceMutation();

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    setShowPopup(true);
  };

  const handleOpen = () => {
    setShowPopup(true);
  };

  const handleclose = () => {
    setShowPopup(false);
    reset();
  };

  const preDefaultValues = () => ({
    Frequency: "DAILY",
    retain_comments: false,
    retain_subtasks: false,
    set_to_previous_business_day: false,
    create_next_after_close: true,
    end_value: 2,
    interval_value: 1,
  });

  useEffect(() => {
    if (recurrenceList) {
      reset({
        // Frequency: recurrenceList.frequency,
        // interval_value: recurrenceList.interval_value,
        // // end_type: "AFTER",
        // end_value: recurrenceList.end_value,
        // retain_comments: recurrenceList.retain_comments,
        // retain_subtasks: recurrenceList.retain_subtasks,
        // set_to_previous_business_day:
        //   recurrenceList.set_to_previous_business_day,
        // create_next_after_close: recurrenceList.create_next_after_close,

        Frequency: recurrenceList.frequency ? recurrenceList.frequency : "DAILY",
        retain_comments: recurrenceList?.retain_comments === 1 ? true : false,
        retain_subtasks: recurrenceList?.retain_subtasks === 1 ? true : false,
        set_to_previous_business_day: recurrenceList?.set_to_previous_business_day === 1 ? true : false,
        create_next_after_close: true,
        end_value:
          recurrenceList?.end_value === null
            ? "never"
            : recurrenceList?.end_value || 2,
        interval_value: recurrenceList?.interval_value || 1,
      });
      const label = `Every ${recurrenceList.interval_count} ${
        recurrenceList.frequency === "DAILY"
          ? "Days"
          : recurrenceList.frequency === "WEEK"
          ? "Weeks"
          : recurrenceList.frequency === "MONTH"
          ? "Months"
          : recurrenceList.frequency === "YEAR"
          ? "Years"
          : ""
      }`;
      refetch();

      setSelectedValue(label);
    } 
    else {
      reset(preDefaultValues);
    }
  }, [recurrenceList, reset]);

  const frequencyWatch = watch("Frequency");
  //   const handleRemainder = (data) => {
  //     // alert("Submitted!");
  //     setSelectedValue(
  //       data.remainderTask,
  //       dayjs(data.date).format("DD/MM/YYYY"),
  //       data.time
  //     );
  //     console.log("task_remainder_form_data :", data);
  //   };

  const handleRemainder = async (data) => {
    // console.log("recurrence_data :", data);
    const requestedData = {
      // Frequency: "none",
      // retain_comments: false,
      // retain_subtasks: false,
      // set_to_previous_business_day: false,
      // create_next_after_close: true,
      task_id: Number(id),
      frequency: data.Frequency,
      interval_value: data.interval_value,
      end_type: endTypeWatch === "never" ? "INFINITE" : "AFTER",
      end_value: endTypeWatch === "never" ? null : data.end_value,
      retain_comments: data.retain_comments,
      retain_subtasks: data.retain_subtasks,
      set_to_previous_business_day: data.set_to_previous_business_day,
      create_next_after_close: data.create_next_after_close,
    };
    try {
      const response = await createTaskRecurrence({
        url: recurrenceList ? `task/recurring/update` : `task/recurring`,
        data: requestedData,
      }).unwrap();
      if (response) {
        refetch();
        setShowPopup(false);
        toast.success(response?.data?.message || response.message);
        if (data.Frequency === "NONE") {
          setSelectedValue(""); // Clear the label
        } 
        else {
          const label = `Every ${data.interval_value} ${
            data.Frequency === "DAILY"
              ? "Days"
              : data.Frequency === "WEEK"
              ? "Weeks"
              : data.Frequency === "MONTH"
              ? "Months"
              : data.Frequency === "YEAR"
              ? "Years"
              : ""
          }`;
          setSelectedValue(label);
        }
      }
    } 
    catch (error) {
      // console.error(error.message);
      toast.error(error?.data?.message || error.message);
    }
    // setSelectedValue(label);
    // console.log("task_remainder_form_data :", data);
  };
  const endTypeWatch = watch("end_value");

  return (
    <>
      {/* <FormControl fullWidth>
        <Select
          value={selectedValue}
          onOpen={handleOpen}
          // onClose={handleclose}
          // onBlur={(e) => handleBlur(e, nameChange.task_id)}
          // name="remainderTask"
        />
      </FormControl> */}
      <FormControl fullWidth>
        <TextField
          disabled={disabled}
          value={selectedValue || "Set Recurrence"}
          onClick={handleOpen}
          InputProps={{
            readOnly: true,
          }}
        />
      </FormControl>

      <Modal show={showPopup} onHide={handleclose}>
        <form action="" onSubmit={handleSubmit(handleRemainder)}>
          <Modal.Header closeButton>
            <Modal.Title>Task Recurrence</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container">
              <div className="row align-items-center  mb-3">
                <div className="col-md-6 mb-3">Recurring Frequency</div>

                <div className="col-md-6 mb-3">
                  <Controller
                    name="Frequency"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select {...field} displayEmpty>
                          <MenuItem value="NONE">None</MenuItem>
                          <MenuItem value="DAILY">Daily</MenuItem>
                          <MenuItem value="WEEK">Weekly</MenuItem>
                          <MenuItem value="MONTH">Monthly</MenuItem>
                          <MenuItem value="YEAR">Yearly</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row my-2">
                <div className="col-md-5">Once Every</div>
                <div className="col-md-3">
                  <Controller
                    name="interval_value"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select {...field}>
                          {Array.from({ length: 15 }, (_, i) => {
                            const value = i + 1;
                            return (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-4">
                  {frequencyWatch === "DAILY"
                    ? "Day(s)"
                    : frequencyWatch === "WEEK"
                    ? "Week(s)"
                    : frequencyWatch === "MONTH"
                    ? "Month(s)"
                    : frequencyWatch === "YEAR"
                    ? "Year(s)"
                    : ""}
                </div>
              </div>

              <div className="row my-2">
                <div className="col-md-5">End After</div>
                <div className="col-md-3">
                  <Controller
                    name="end_value"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          renderValue={(selected) =>
                            selected === "never" ? "∞" : selected
                          }
                        >
                          {Array.from({ length: 30 }, (_, i) => {
                            const value = i + 2;
                            return (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            );
                          })}
                          <MenuItem value="never">Never</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                <div className="col-4">Occurrence(s)</div>
              </div>

              <div className="row">
                {(frequencyWatch === "MONTH" || frequencyWatch === "YEAR") && (
                  <div className="col-12">
                    <Controller
                      name="set_to_previous_business_day"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <FormControlLabel
                          control={
                            <Checkbox {...field} checked={field.value} />
                          }
                          label="Set to previous business day"
                        />
                      )}
                    />{" "}
                  </div>
                )}

                <div className="col-12">
                  <Controller
                    name="retain_comments"
                    control={control}
                    defaultValue={false}
                    render={({ field }) => (
                      <FormControlLabel
                        control={<Checkbox {...field} checked={field.value} />}
                        label="Retain comments for subsequent recurrences"
                      />
                    )}
                  />
                </div>

                <div className="col-12">
                  <Controller
                    name="retain_subtasks"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={<Checkbox {...field} checked={field.value} />}
                        label="Retain subtasks for subsequent recurrences"
                      />
                    )}
                  />
                </div>
                
                <div className="col-12" style={{ cursor: "not-allowed" }}>
                  <Controller
                    name="create_next_after_close"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <Checkbox {...field} disabled checked={field.value} />
                        }
                        label="Create next recurrence after closing the current task"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            {/* <button className="btn btn-secondary" onClick={handleclose}>
              Cancel
            </button> */}
            {/* <button className="btn btn-primary" type="submit">
              Save
            </button> */}
            {!recurrenceList && (
              <button
                className=" addmore_btn"
                // disabled={isLoading}
                type="submit"
              >
                Save
              </button>
            )}

            {recurrenceList && (
              <button
                className=" addmore_btn"
                // disabled={isLoading}
                type="submit"
              >
                Update
              </button>
            )}
            
            {/* {recurrenceList && (
              <button
                className=" cancel_btn"
                onClick={handleDeleteRemainder}
                type="button"
                // disabled={loading}
              >
                Delete
              </button>
            )} */}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default TaskRecurrence;
